import { Organization } from "@App/types";
import { Organizations } from "@App/types/enums";

export const OrganizationHasCheckedByBadge = (organization: Organization | null) => {
  return organization !== null && ![Organizations.DBCONNECT].includes(organization?.id);
};

export const OrganizationIsArval = (organization: Organization | null) => {
  return organization?.id === Organizations.ARVAL;
};

export const OrganizationIsRepareo = (organization: Organization | null) => {
  return organization?.id === Organizations.REPAREO;
};

export const OrganizationIsAyvens = (organization: Organization | null) => {
  return organization?.id === Organizations.AYVENS;
};

export const OrganizationIsMobilityConcept = (organization: Organization | null) => {
  return organization?.id === Organizations.MOBILITYCONCEPT;
};

export const OrganizationIsDBConnect = (organization: Organization | null) => {
  return organization?.id === Organizations.DBCONNECT;
};

export const OrganizationIsSantander = (organization: Organization | null) => {
  return organization?.id === Organizations.SANTANDER;
};

export const OrganizationIsFinn = (organization: Organization | null) => {
  return organization?.id === Organizations.FINN;
};

export const OrganizationIsDeutscheLeasing = (organization: Organization | null) => {
  return (
    organization?.id === Organizations.DEUTSCHELEASING ||
    organization?.id === Organizations.DEUTSCHELEASINGBOSCH
  );
};

export const OrganizationIsAkf = (organization: Organization | null) => {
  return organization?.id === Organizations.AKF;
};

export const OrganizationIsAkfLangzeitmiete = (organization: Organization | null) => {
  return organization?.id === Organizations.AKFLANGZEITMIETE;
};

export const OrganizationIsNio = (organization: Organization | null) => {
  return organization?.id === Organizations.NIO;
};

export const OrganizationIsMeinAuto = (organization: Organization | null) => {
  return organization?.id === Organizations.MEINAUTO;
};

export const OrganizationIsFleethub = (organization: Organization | null) => {
  return organization?.id === Organizations.FLEETHUB;
};

export const OrganizationIsAkfOrAkfLangzeitmiete = (organization: Organization | null) => {
  return OrganizationIsAkf(organization) || OrganizationIsAkfLangzeitmiete(organization);
};

export const OrganizationIsAthlon = (organization: Organization | null) => {
  return organization?.id === Organizations.ATHLON;
};

export const OrganizationIsALD = (organization: Organization | null) => {
  return organization?.id === Organizations.ALD;
};

export const OrganizationIsItzehoer = (organization: Organization | null) => {
  return organization?.id === Organizations.ITZEHOER;
};

export const OrganizationIsRaiffeisen = (organization: Organization | null) => {
  return organization?.id === Organizations.RAIFFEISEN_IMPULS_DE;
};

export const OrganizationIsMobileGarantie = (organization: Organization | null) => {
  return organization?.id === Organizations.MOBILE_GARANTIE;
};

export const OrganizationIsMFS = (organization: Organization | null) => {
  return organization?.id === Organizations.MFS;
};

export const OrganizationIsMARA = (organization: Organization | null) => {
  return organization?.id === Organizations.MARA;
};

export const OrganizationIsSignalIduna = (organization: Organization | null) => {
  return organization?.id === Organizations.SIGNALIDUNA;
};
